import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { format, parseISO } from "date-fns";
import { FieldConfig } from "src/app/interfaces/field.interface";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ProverDatepickerComponent } from "../../prover-datepicker/prover-datepicker";
@Component({
  selector: "app-date",
  template: `
    <ng-container [formGroup]="group">
      <div class="padding-datepicker">
        <prover-datepicker
          [labelName]="field.label"
          [id]="field.name"
          [formControlName]="field.name"
          [required]="
            field.validations && field.validations[0] && field.validations[0].name == 'required' ? true : false
          "
          [isDataAtual]="field.name === 'nascimento' ? true : false"
        ></prover-datepicker>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of field.validations">
            <div
              class="error-message"
              *ngIf="
                group.get(field.name)?.hasError(validation.name) &&
                (group.get(field.name)?.dirty || group.get(field.name)?.touched)
              "
            >
              {{ "Campo Obrigatório" | translate }}
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  `,
  styles: [
    `
      .padding-datepicker {
        padding-left: 20px !important;
        padding-right: 25px !important;
      }

      .error-message {
        padding-bottom: 10px !important;
        font-size: 12px !important;
      }

      .validation-errors {
        margin-left: 16px;
      }
    `,
  ],
  standalone: true,
  imports: [DateFormatPipe, IonicModule, CommonModule, TranslateModule, ReactiveFormsModule, ProverDatepickerComponent],
})
export class DateComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  constructor() {}
  ngOnInit() {
    if (this.field.value) {
      this.field.value = format(parseISO(this.field.value), "yyyy-MM-dd");
    }
  }

  changeDate(event: any) {
    this.field.value = format(parseISO(event.detail.value), "yyyy-MM-dd");
  }
}
